import { render, staticRenderFns } from "./TenderTitle.vue?vue&type=template&id=62698138"
import script from "./TenderTitle.vue?vue&type=script&lang=js"
export * from "./TenderTitle.vue?vue&type=script&lang=js"
import style0 from "./TenderTitle.vue?vue&type=style&index=0&id=62698138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports